import { createFileRoute } from '@tanstack/react-router'

import { CalendarPage } from '@/features/calendar/calendar-page'
import { calendarSearchSchema } from '@/features/calendar/search'

export const Route = createFileRoute('/_app/calendar')({
  validateSearch: (search) => calendarSearchSchema.parse(search),
  component: CalendarPage,
})
